import React from "react";
import { CustomInput } from "../../common/SimpleInput"
import { Button, Divider } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    button:{
        height: 29,
        textTransform: "none",
        fontSize: "12px",
        margin: 5,
        backgroundColor: "#3B5158",
        boxSizing: "border-box",
        "&:hover":{
        backgroundColor: "#3B5158"
        }
    }
  
  }));

function WorkshopForm(props){

const {formState, handleChange, handleSubmit, loading, options} = props;
const classes = useStyles()
    return(
        <form onSubmit={handleSubmit} style={{padding: 4}}>
            <CustomInput size={"xxs"}  onChange={(e)=>handleChange(e, "address")} label="Dirección" type="text"  value={formState.address} />
           <div style={{display: "flex", alignItems: "flex-end", justifyContent: "space-between"}}>
                <CustomInput size={"xxs"} onChange={(e)=>handleChange(e, "postalCode")} label="Código postal" type="text"  value={formState.postalCode} />
                <CustomInput disableClear label="Tipo" type="select" displayExpr={"workshopType"} valueExpr={"workshopType"} options={options} value={formState.searchOption} onChange={(e) => handleChange(e, "searchOption")} />        
                <Button disabled={loading === "loading"} disableElevation classes={{root: classes.button}} type="submit" variant="contained" color="primary">Buscar</Button>
            </div>
            <Divider/>   
        </form>
    )
}

export {WorkshopForm}